import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import {ProductModel} from '../../product-category/models/product.model';

@Component({
  selector: 'app-resource-product-select',
  template: `

  <div>
    <button (click)="this.clicked($event)" style="background-color: #A50034 !important; border-color: #A50034 !important; height: 32px; width: 225px; border-radius: 4px; display: flex; align-items: center; justify-content: center" class="btn btn-primary"
       href="">{{this.model.title}}</button>
  </div>
  `,
  styles: [
    `
      .caption {
        height: 145px;
        width: 100%;
      }
      .thumbnail {
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.6);
        background-color: #ffffff;
        margin-bottom: 25px;
        max-height: 400px;
        max-width: 300px;
        padding-top: 15px;
        margin-left: auto;
        margin-right: auto;
      }
      .flex-text {
        flex-grow: 1;
      }
      img {
        min-width: 0;
        height: auto;
        max-width: 100%;
      }

      .product-title {
        height: 25px !important;
        width: 202px !important;
        color: #4a4a4a !important;
        font-family: 'LGEIRegular';
        font-size: 18px !important;
        font-weight: bold !important;
        line-height: 25px !important;
        text-align: center !important;
      }

      @media (max-width: 795px) {
        .thumbnail {
          width: 280px !important;
        }

        img {
          width: 100% !important;
        }
      }
    `
  ]
})
export class ProductSelectComponent  {
  @Input() model: ProductModel;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  class: string;

  clicked($event) {
    this.selected.emit(this.model.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/components/product-select.component.ts